import { render } from "./OfficePages.vue?vue&type=template&id=370061a2"
import script from "./OfficePages.vue?vue&type=script&lang=js"
export * from "./OfficePages.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__